import { CommPhoneNumberService } from '@weave/schema-gen-ts/dist/schemas/comm/phone-number/v1/phone_number_service.pb';
import { bindHTTP } from '@frontend/schema';

export const SchemaCommPhoneNumberV1Service = bindHTTP(CommPhoneNumberService);
